<!--
 * @Author: your name
 * @Date: 2022-03-22 22:32:26
 * @LastEditTime: 2022-04-10 22:09:28
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \web_page_pc\src\page\Leaderboard.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <MainNav />
        <el-container>
            <div class="main_box">
                <el-main>
                    <div class="left_box">
                        <a>銷量總榜</a>
                    </div>
                    <div class="right_box">
                        <div class="right_title">
                            銷量總榜
                        </div>
                        <el-table ref="multipleTable"
                                  v-loading="isLoading"
                                  :data="leaderboard_list"
                                  stripe
                                  style="width: 100%">
                            <el-table-column type="index"
                                             width="50"
                                             align="center">
                            </el-table-column>
                            <el-table-column label="圖片"
                                             width="140"
                                             align="center"
                                             header-align="left">
                                <template slot-scope="scope">
                                    <img class="goods_img"
                                         :src="scope.row.image">
                                </template>
                            </el-table-column>
                            <el-table-column prop="name"
                                             label="名稱">
                            </el-table-column>
                            <el-table-column prop="brand_name"
                                             label="品牌"
                                             width="140">
                            </el-table-column>
                            <el-table-column prop="classify_name"
                                             label="類型"
                                             width="140">
                            </el-table-column>
                            <el-table-column prop="price"
                                             label="單價"
                                             width="140">
                                <template slot-scope="scope">
                                    <span>{{ amountFormatte(scope.row.price) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作"
                                             width="150">
                                <template slot-scope="scope">
                                    <router-link :to="`/Good?id=${scope.row.id}`"
                                                 target="_blank">
                                        <el-button size="mini"
                                                   type="danger">
                                            查看商品
                                        </el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-main>
            </div>
        </el-container>
        <MainFooter />
    </div>
</template>

<script>
import MainHeader from "@/components/Header";
import MainNav from "@/components/MainNav";
import MainFooter from "@/components/Footer";
import { leaderBoard } from "@/api/goodsAPI";
import { changeImage, amountFormatte } from "@/utils";

export default {
    components: {
        MainHeader,
        MainNav,
        MainFooter,
    },
    data() {
        return {
            leaderboard_list: [],
            leaderboard_type: "all",
            isLoading: false,
        };
    },
    created() {
        this.leaderBoard();
    },
    methods: {
        amountFormatte,
        async leaderBoard() {
            this.isLoading = true;
            let result = await leaderBoard(this.leaderboard_type);
            this.leaderboard_list = changeImage(
                150,
                150,
                result.leaderboard,
                "thumb"
            );
            this.isLoading = false;
        },
    },
};
</script>

<style scoped lang="scss">
.main_box {
    width: 1240px;
    margin: 0 auto;
    margin-top: 10px;
    .el-main {
        width: 1240px;
        padding: 0;
        background-color: #fff;
        border: 1px solid #d3d3d3;
        .left_box {
            width: 200px;
            float: left;
            margin-top: 20px;
            a {
                display: block;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                text-indent: 20px;
                cursor: pointer;
            }
            a:hover {
                background-color: #eee;
            }
        }
        .right_box {
            width: 1037px;
            float: right;
            border-left: 1px solid #d3d3d3;
            .right_title {
                height: 70px;
                line-height: 70px;
                font-size: 24px;
                font-weight: bold;
                text-indent: 30px;
                border-bottom: 1px solid #d3d3d3;
            }
            img {
                width: 100px;
                box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
            }
        }
    }
}
</style>
